import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { BaseSiteService, RoutingService, StateWithProcess } from '@spartacus/core';
import { ItemService } from '@spartacus/organization/administration/components';
import {
  OrganizationItemStatus,
  StateWithOrganization
} from '@spartacus/organization/administration/core';
import { UigB2BUser } from '../../uig-user/uig-user.model';
import { AccessSubjectFunctionalKeys } from '../../store/uig-access-subject/uig-access-subject.model';
import { UigCurrentUserService } from '../uig-current-user/uig-current-user.service';
import { UigUserFormService } from '../uig-user-form/uig-user-form.service';
import { UigB2BUserService } from '../uig-b2b-user/uig-b2b-user.service';
import * as UigB2BUserActions from '../../store/uig-b2b-user/uig-b2b-user.action';
import { defaultUserGroupsForNewCustomers } from '../../uig-user/uig-user';

@Injectable({
  providedIn: 'root',
})
export class UigUserItemService extends ItemService<UigB2BUser> {
  key$ = this.currentItemService.key$;

  constructor(
    protected currentItemService: UigCurrentUserService,
    protected routingService: RoutingService,
    protected uigUserformService: UigUserFormService,
    protected uigB2BUserService: UigB2BUserService,
    protected store: Store<StateWithOrganization | StateWithProcess<void>>,
    protected baseSiteService: BaseSiteService
  ) {
    super(currentItemService, routingService, uigUserformService);
  }

  public load(code?: string): Observable<UigB2BUser> {
    this.uigB2BUserService.load(code);

    return this.uigB2BUserService.get(code);
  }

  public create(value: UigB2BUser): Observable<OrganizationItemStatus<UigB2BUser>> {
    this.addDefaultUserGroupsForNewCustomers(value);
    this.uigB2BUserService.create(value);
    return this.uigB2BUserService.getLoadingStatus(value.uid);
  }

  public update(code: string, value: UigB2BUser): Observable<OrganizationItemStatus<UigB2BUser>> {
    // Prepare the object that is sent to the back-end
    value = this.normalizeUserObject(value);
    this.uigB2BUserService.update(code, value);
    return this.uigB2BUserService.getLoadingStatus(code);
  }

  protected getDetailsRoute(): string {
    return 'orgUserDetails';
  }

  public deleteUser(userId: string): Observable<OrganizationItemStatus<UigB2BUser>> {
    this.store.dispatch(
      new UigB2BUserActions.DeleteB2BUser({
        userId
      })
    );
    return this.uigB2BUserService.getLoadingStatus(userId);
  }

  public getForm(item?: UigB2BUser): UntypedFormGroup {
    return this.uigUserformService.getForm(item);
  }

  private normalizeUserObject(userObj: UigB2BUser): UigB2BUser {
    const keysToBeRemoved: string[] = [
      AccessSubjectFunctionalKeys.SUI_GENERIS_PERMISSION,
    ]

    keysToBeRemoved.forEach((key: string) => {
      if (Object.prototype.hasOwnProperty.call(userObj, key)) {
        delete userObj[key];
      }
    });

    return userObj;
  }

  addDefaultUserGroupsForNewCustomers(item: UigB2BUser) {
    item.roles.push(...defaultUserGroupsForNewCustomers);
  }
}
